module.exports = __webpack_public_path__ + "img/MAC320_Z.d4e8fa44.png";